import React, { useEffect, useState } from "react";
import { conciergeAuthFetch } from "../../../../utils/conciergeCmsAuth";

function formatDate(value) {
  if (!value) return "-";
  try {
    return new Intl.DateTimeFormat("ko-KR", {
      timeZone: "Asia/Seoul",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(new Date(value));
  } catch {
    return String(value);
  }
}

export default function ConciergeUserRefunds() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const run = async () => {
      try {
        const res = await conciergeAuthFetch("/concierge/user/refunds");
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data?.detail || "환불 내역을 불러오지 못했습니다.");
        setItems(data.items || []);
      } catch (err) {
        setError(err.message || "환불 내역을 불러오지 못했습니다.");
      } finally {
        setLoading(false);
      }
    };
    run();
  }, []);

  return (
    <div className="px-8 py-8">
      <h1 className="text-2xl font-bold text-[#111827]">환불 내역</h1>
      <div className="mt-6 overflow-hidden rounded-2xl border border-[#ebeef5] bg-white">
        {loading ? (
          <div className="px-6 py-10 text-sm text-[#6b7280]">로딩 중입니다...</div>
        ) : error ? (
          <div className="px-6 py-10 text-sm text-red-500">{error}</div>
        ) : items.length === 0 ? (
          <div className="px-6 py-10 text-sm text-[#6b7280]">환불 내역이 없습니다.</div>
        ) : (
          <table className="min-w-full text-sm">
            <thead className="bg-[#f8fafc] text-[#6b7280]">
              <tr>
                <th className="px-4 py-3 text-left">처리일</th>
                <th className="px-4 py-3 text-left">상품명</th>
                <th className="px-4 py-3 text-left">유형</th>
                <th className="px-4 py-3 text-left">토큰</th>
                <th className="px-4 py-3 text-left">금액</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#eef2f7]">
              {items.map((item) => (
                <tr key={`${item.purchase_id}-${item.created_at}`}>
                  <td className="px-4 py-4">{formatDate(item.created_at)}</td>
                  <td className="px-4 py-4">{item.ticket_name || "-"}</td>
                  <td className="px-4 py-4">{item.transaction_type || "-"}</td>
                  <td className="px-4 py-4">{item.purchased_tokens ?? "-"}</td>
                  <td className="px-4 py-4">{item.ticket_price ?? "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

